var SpriteSymbol = require("../../../../../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "new",
  "use": "new-usage",
  "viewBox": "0 0 57 57",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 57 57\" id=\"new\">\n  <path id=\"new_Icon_Neuer_Eintrag\" class=\"cls-1\" d=\"M1226.5,1180a28.5,28.5,0,1,1,28.5-28.5A28.532,28.532,0,0,1,1226.5,1180Zm0-55a26.5,26.5,0,1,0,26.5,26.5A26.526,26.526,0,0,0,1226.5,1125Zm10.77,28h-22a1,1,0,0,1,0-2h22A1,1,0,0,1,1237.27,1153Zm-11,11a1,1,0,0,1-1-1v-22a1,1,0,0,1,2,0v22A1,1,0,0,1,1226.27,1164Z\" transform=\"translate(-1198 -1123)\" />\n</symbol>"
});
var result = sprite.add(symbol);
module.exports = "#" + symbol.id